import { FC, useCallback } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import s from './info-card.module.scss'

import { IInfoCardRow } from './info-card-types'
import { Button } from '../button'
import UpdateInfoCardRowModal from './update-info-card-row-modal'
import { useModal } from '../../hooks'
import { IInfoCardRowFormValues } from '../form'

type InfoCardRowProps = IInfoCardRow & {}

const InfoCardRow: FC<InfoCardRowProps> = props => {
  const { title, value, noValue = '-', hiddenOnNoValue = false, onChange, entityId, options, editHistory, showModifiedIndicator = false } = props

  const { isOpen: isUpdateModalOpen, closeModal: closeUpdateModalOpen, openModal: openUpdateModalOpen } = useModal()

  const onSave = useCallback(
    (values: IInfoCardRowFormValues) => {
      if (onChange && values?.selectedValue && entityId) {
        onChange(entityId, values.selectedValue)
      } else {
        console.warn('InfoCardRow: onChange or selectedValue or entityId is missing')
      }
      closeUpdateModalOpen()
    },
    [onChange, closeUpdateModalOpen, entityId],
  )

  if (hiddenOnNoValue && !value) {
    return null
  }
  
  const isEditable = entityId !== undefined && options !== undefined

  return (
    <div className="d-flex mb-1">
      <div className={s['info-block-title']}>{title}:</div>
      <div className={s['info-block-value']}>{value || noValue}</div>
      {showModifiedIndicator && 
        <OverlayTrigger
          placement="top"
          trigger={["hover", "focus", "click"]}
          overlay={
            <Tooltip
              id="tooltip-internally-modified"
              className="tooltip-auto-width"
            >
              Internally Modified
            </Tooltip>
          }
        >
          <i className={`bi bi-people-fill ${s['info-modified-icon']}`} />
        </OverlayTrigger>
      }
      
      {isEditable && (
        <>
          <Button
            type="ghost-icon"
            className={s['info-edit-btn']}
            onClick={openUpdateModalOpen}
            title="Modify"
          >
            <i className="bi bi-pencil-square" />
          </Button>

          <UpdateInfoCardRowModal 
            isOpen={isUpdateModalOpen}
            closeModal={closeUpdateModalOpen}
            onSave={onSave}
            initialValues={value ? { selectedValue: typeof value === 'string' ? value : String(value) } : undefined}
            label={title}
            options={options}
            editHistory={editHistory}
          />
      </>
      )}
    </div>    
  )
}

export default InfoCardRow
